import { jwtDecode } from 'jwt-decode';

/**
 * Check if the token is valid and not expired
 * @returns {boolean} True if token is valid, false otherwise
 */
export const isTokenValid = () => {
  try {
    const token = localStorage.getItem('token');

    if (!token) {
      return false;
    }

    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    // Check if token has expired
    if (decodedToken.exp && decodedToken.exp < currentTime) {
      // Token expired, clear it from storage
      localStorage.removeItem('token');
      return false;
    }

    return true;
  } catch (error) {
    console.error('Token validation error:', error);
    // If there's any error in decoding (e.g., invalid token format),
    // remove the token and return false
    localStorage.removeItem('token');
    return false;
  }
};

/**
 * API wrapper that checks token validity before making any request
 * @param {string} url - The URL to fetch
 * @param {Object} options - The fetch options
 * @returns {Promise} - The fetch promise
 */
export const authenticatedFetch = async (url, options = {}) => {
  if (!isTokenValid()) {
    // Token is invalid, throw an error to be caught by the caller
    throw new Error('INVALID_TOKEN');
  }

  const token = localStorage.getItem('token');

  // Add authorization header if not already present
  const headers = options.headers || {};
  if (!headers.Authorization && token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return fetch(url, { ...options, headers });
};
